export default __webpack_public_path__ + "static/SCROLL_4-5a53190883835a220f85a8fcfbe10a48.png";